import {
	FilterIdentifiersEnum,
	FilterTypes,
	IFilterBase
} from '@shared/list-operations/model/filter.model';


// ENUMS ##########################################################
export enum SortOrderEnum {
	ASC = 'asc',
	DESC = 'desc',
}

// DECLARATIONS ###################################################


// INTERFACES #####################################################
// TODO remove as soon as SortComponent is obsolete
export interface ISortData {
	name: string;

	i18nPath: string;

	defaultActive?: boolean;

	sortOrder?: SortOrderEnum;
}


export interface ISortFilter extends IFilterBase {

	filterId: FilterIdentifiersEnum.SORT;

	type: FilterTypes.FILTER_SORT_TYPE;

	defaultValue: ISortFilterValue;

	items: ISortFilterItem[];
}

export interface ISortFilterItem {
	value: string;
	i18nPath: string;
}

export interface ISortFilterValue {
	sortCriterion: string;
	sortOrder: SortOrderEnum;
}


// TYPES ##########################################################
export type FilterSortType = string;


// CLASSES ########################################################
